export default __webpack_public_path__ + "img/fjuXaqzg.aad19eec.svg";